// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inp {
  width: 400px;
}

.dialog-container {
  width: 100%;
}

.container {
  width: 1000px;
}

.btn-submit {
  background-color: #0060d6;
  color: white;
  transition: background 0.3s ease-in-out;
}
.btn-submit:hover {
  background-color: #1a1a86;
}`, "",{"version":3,"sources":["webpack://./src/app/features/ada-access/adaptive-access-node-ruleset/adaptive-access-node-ruleset-create-or-update/adaptive-access-node-ruleset-create-or-update.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AAGE;EACA,WAAA;AAAF;;AAIE;EACG,aAAA;AADL;;AAKE;EACA,yBAAA;EACA,YAAA;EACA,uCAAA;AAFF;AAIE;EACE,yBAAA;AAFJ","sourcesContent":[".inp {\n    width: 400px;\n    \n  }\n\n  .dialog-container {\n  width: 100%;\n}\n\n\n  .container{\n     width: 1000px;\n  }\n\n  \n  .btn-submit {\n  background-color: #0060d6;\n  color: #ffff;\n  transition: background 0.3s ease-in-out;\n\n  &:hover{\n    background-color: #1a1a86;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
